import {useCallback} from 'react';
import type {InvitationCategoryType} from '~/common/components/MegaNav/MegaNavVariant/types';
import {Link} from '~library/atoms/Link';
import {useTracking} from '~library/context/tracking/tracking-context';
import * as styles from './MarketingBanner.module.scss';

type MarketingBannerProps = {
  hoveredCategory: InvitationCategoryType | null;
};

export const MarketingBanner = ({hoveredCategory}: MarketingBannerProps) => {
  const {track} = useTracking();

  const handleBannerClick = useCallback(() => {
    if (hoveredCategory) {
      track({
        dataQaId: 'marketing-banner',
        href: hoveredCategory.bannerUrl || '#',
        bannerText: hoveredCategory.bannerText,
        categoryTitle: hoveredCategory.title,
      });
    }
  }, [track, hoveredCategory]);

  if (!hoveredCategory?.bannerText) {
    return null;
  }

  return (
    <Link
      href={hoveredCategory.bannerUrl || '#'}
      className={styles.bannerUrl}
      data-qa-id="marketing-banner"
      onClick={handleBannerClick}
    >
      {hoveredCategory.bannerText}
    </Link>
  );
};
